import {
  Box,
  Button,
  TextField,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostDatosProductosTejidos } from "../../services/productosTejidos.services";
import ModalCharge from "../../modal/modalCharge";
import MenuItem from "@mui/material/MenuItem";
import imageCompression from "browser-image-compression";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl';
import {
  getOneSerieDep,
  PostAmoxarifado,
  PostDepositoRandom,
} from "../../services/amoxarifado.services";
import ModalCategoriasAmoxarifado from "../../modal/amoxarifado/modalCategorias";
import ModalSubCategoriasAmoxarifado from "../../modal/amoxarifado/modalSubCategorias";
import { useDropzone } from "react-dropzone";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import ModalUserData from "../../modal/user/modalUserData";
import ModalPatrimonio from "../../modal/amoxarifado/modalPatrimonio";
import ModalSector from "../../modal/amoxarifado/modalSector";
import { set } from "date-fns";
import secureStorage from "../../utils/secureStorage";

const SalidaProduct = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isModalCategoriaOpen, setIsModalCategoriaOpen] = useState(false);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [subcategoriaSeleccionada, setSubcategoriaSeleccionada] =
    useState(null);
  const [isModalSubcategoriaOpen, setIsModalSubcategoriaOpen] = useState(false);
  const [modalUserOpen, setModalUserOpen] = useState(false);
  const [modalPatrimonio, setModalPatrimonio] = useState(false);
  const [modalSector, setModalSector] = useState(false);
  const [modalJustClosed, setModalJustClosed] = useState(false);

  const [idCategoriaActual, setIdCategoriaActual] = useState(null);
  const [imageBase64, setImageBase64] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [tipo, setTipo] = useState("");
  const [descuento, setDescuento] = useState("");
  const [droppedItems, setDroppedItems] = useState([]);
  const [dropError, setDropError] = useState("");
  const [data, setData] = useState([]);
  const [Onedata, setOnedata] = useState([]);
  const [serieValue, setSerieValue] = useState("");
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const formikRef = useRef(null); // useRef en lugar de useState
  const inputRef = useRef(null);
  const cantidadRef = useRef(null);
  const patrimonioRef = useRef(null);

  const [dataSend, setDataSent] = useState([]);
  const [valuesToSend, setValuesToSend] = useState([]);

  // const [valuesToSend, setValuesToSend] = useState([{
  //   operacion: "Salida",
  //   id_producto: null,
  //   deposito: null,
  //   estante: null,
  //   fila: null,
  //   columna: null,
  //   cantidad: null,
  //   id_usuario: null,
  //   usuario_re: null,
  //   id_patrimonio: null,
  //   estado_devolucion: null,
  // }]);

  const usuarioId = Number(secureStorage.getItem("id"));

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    // const { producto, cod, cant_min, columna, fila, imagen, id_subcategoria} = values;

    // const valuesToSend = {
    //     producto,
    //     cod,
    //     cant_min: parseInt(cant_min),
    //     columna,
    //     fila: parseInt(fila),
    //     id_categoria: id_subcategoria,
    // };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await PostDepositoRandom(valuesToSend);
       setRegistrationSuccess(true);
      // resetForm();
      // setCategoriaSeleccionada(null);
      // setSubcategoriaSeleccionada(null);
      // setIdCategoriaActual(null);
      // setDroppedItems([]);
      // setImageBase64("");
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "cod", headerName: "Codigo", flex: 1 },

    {
      field: "producto",
      headerName: "Producto",
      flex: 2,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    // {
    //   field: "id_usuario",
    //   headerName: "Usuario",
    //   flex: 2,
    //   type: "number",
    //   headerAlign: "left",
    //   align: "left",
    // },
    {
      field: "deposito",
      headerName: "Deposito",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "estante",
      headerName: "Estante",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "fila",
      headerName: "Fila",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "columna",
      headerName: "Columna",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "id_patrimonio",
      headerName: "Patrimonio",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "operacion",
      headerName: "Operacion",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
  ];

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "F9" ||
        (event.key === "Tab" && document.activeElement.name === "id_level")
      ) {
        // setIsModalLevelOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (serieValue) {
      const fetchDatos = async () => {
        try {
          const data = await getOneSerieDep(serieValue);
          setOnedata(data);
          setDataSent((prev) => [...prev, data]);
          setFieldValuesInFormik(data); // Actualizamos los valores de Formik con los datos obtenidos
          cantidadRef.current.focus();
        } catch (error) {
          console.error("Error al obtener datos:", error.message);
        }
      };

      fetchDatos();
    }

    // try {
    //   const fetchMotivos = async () => {
    //     const response = await getMotivoCalandra();
    //     // const motivos = response.map()
    //     setMotivosData(response);

    //  }
    //  fetchMotivos();
    // } catch (error) {
    //   console.error('Error al obtener datos del backend:', error);
    // }
  }, [serieValue]); // Dependencias actualizadas

  const setFieldValuesInFormik = (data) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue("id_producto", data.id_producto);
      formikRef.current.setFieldValue("producto", data.producto);
    }
  };

  const handleAddRow = (values, setFieldValue) => {
    const operacionActual = formikRef.current.values.operacion;

    if (values.id_patrimonio === "" || values.id_patrimonio === null) {
      setRegistrationError(true);
      setError("Debe seleccionar un patrimonio");
      return;
    } else {
      const lastData = dataSend[dataSend.length - 1];
      // Crea un nuevo objeto con los valores actuales del formulario
      const newRow = {
        id: Onedata.id, // o usa otro identificador único
        producto: values.producto,
        id_patrimonio: values.id_patrimonio,
        cantidad: values.cantidad,
        id_patrimonio: values.id_patrimonio,
        // id_usuario: values.id_usuario,
        cod: Onedata.cod,
        deposito: lastData?.deposito,
        estante: lastData?.estante,
        fila: lastData?.fila,
        columna: lastData?.columna,
        operacion: operacionActual,

        // agrega otros campos si lo necesitas
      };
      setData((prev) => [...prev, newRow]);
      setValuesToSend((prev) => [
        ...prev,
        {
          operacion: operacionActual,
          id_producto: lastData?.id,
          deposito: lastData?.id_deposito,
          estante: lastData?.id_estante,
          fila: lastData?.id_fila,
          columna: lastData?.id_columna,
          cantidad: values.cantidad,
          usuario_re: values.id_usuario,
          // usuario_re: lastData?.id_usuario,
          id_patrimonio: values.id_patrimonio,
          estado_devolucion: 2,
        },
      ]);

      // Limpia los campos si lo deseas
      setFieldValue("producto", "");
      setFieldValue("cantidad", "");
      setFieldValue("serie", "");
      // setFieldValue("id_patrimonio", "");
      setFieldValue("id_producto", "");
    }

    // Hacer focus en el input de serie
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <Box m="20px">
      <Header title="Salida Productos" subtitle="Salida Productos" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces
          open={registrationSuccess}
          onClose={() => setRegistrationSuccess(false)}
        />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={() => setRegistrationError(false)}
          error={error}
        />
      )}

      <Formik
        innerRef={formikRef}
        onSubmit={handleFormSubmit}
        initialValues={{
          id_usuario: "",
          id_producto: "",
          producto: "",
          cantidad: "",
          id_patrimonio: "",
          id_sector: "",
          serie: "",
          operacion: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <>
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.type !== "textarea") {
                  e.preventDefault();
                }
              }}
            >
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  select
                  fullWidth
                  variant="filled"
                  label="Operación"
                  name="operacion"
                  value={values.operacion}
                  onChange={handleChange}
                  error={!!touched.operacion && !!errors.operacion}
                  helperText={touched.operacion && errors.operacion}
                  sx={{ gridColumn: "span 1" }}
                >
                  <MenuItem value="SALIDA">SALIDA</MenuItem>
                  <MenuItem value="PRESTAMO">PRÉSTAMO</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Usuario"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.id_usuario}
                  name="id_usuario"
                  error={!!touched.id_usuario && !!errors.id_usuario}
                  helperText={touched.id_usuario && errors.id_usuario}
                  sx={{ gridColumn: "span 1" }}
                  onClick={() => setModalUserOpen(true)}
                />
                {/* <TextField
                fullWidth
                variant="filled"
                type="text"
                label="ID Producto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.id_producto}
                name="id_producto"
                error={!!touched.id_producto && !!errors.id_producto}
                helperText={touched.id_producto && errors.id_producto}
                sx={{ gridColumn: "span 1" }}
              /> */}
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Serie"
                  inputRef={inputRef} // Asocia el inputRef al campo
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e); // Llama el handleChange normal de Formik
                    setSerieValue(e.target.value); // Actualiza el valor de serieValue
                  }}
                  value={values.serie}
                  name="serie"
                  error={!!touched.serie && !!errors.serie}
                  helperText={touched.serie && errors.serie}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Producto"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.producto}
                  name="producto"
                  error={!!touched.producto && !!errors.producto}
                  helperText={touched.producto && errors.producto}
                  sx={{ gridColumn: "span 2" }}
                  disabled={true} // Deshabilitado para evitar cambios manuales
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Cantidad"
                  inputRef={cantidadRef}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.cantidad}
                  name="cantidad"
                  error={!!touched.cantidad && !!errors.cantidad}
                  helperText={touched.cantidad && errors.cantidad}
                  sx={{ gridColumn: "span 1" }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      // Focus en el campo Patrimonio
                      if (patrimonioRef.current) patrimonioRef.current.focus();
                    }
                  }}
                />

                {/* <TextField
                  fullWidth
                  variant="filled"
                  label="Sector"
                  name="id_sector"
                  // value={subcategoriaSeleccionada?.subcategoria || ""}
                  value={values.id_sector}
                  onClick={() => setModalSector(true)}
                  // InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 1", cursor: "pointer" }}
                  error={!!touched.id_sector && !!errors.id_sector}
                  helperText={touched.id_sector && errors.id_sector}
                /> */}

                <TextField
                  fullWidth
                  variant="filled"
                  label="Patrimonio"
                  name="id_patrimonio"
                  inputRef={patrimonioRef} // <--- asociamos el ref
                  value={values.id_patrimonio}
                  // onClick={() => setModalSector(true)}
                  sx={{ gridColumn: "span 1", cursor: "pointer" }}
                  error={!!touched.id_patrimonio && !!errors.id_patrimonio}
                  helperText={touched.id_patrimonio && errors.id_patrimonio}
                  onFocus={() => {
                    if (!modalJustClosed) {
                      setModalSector(true);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddRow(values, setFieldValue);
                    }
                  }}
                />
              </Box>
              <Box
                m="40px 0 0 0"
                height="46vh"
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.greenAccent[300],
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[900],
                    borderBottom: "none",
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400],
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[900],
                  },
                  "& .MuiCheckbox-root": {
                    color: `${colors.greenAccent[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                  },
                }}
              >
                <DataGrid
                  rows={data}
                  getRowId={(row) => row.id} // Acceder correctamente al campo `Id`
                  columns={columns}
                  components={{ Toolbar: GridToolbar }}
                  disableMultipleSelection={true}
                />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#bac609" },
                  }}
                >
                  Registrar
                </Button>
              </Box>
              <ModalCharge isLoading={isLoading} />
            </form>
            <ModalCategoriasAmoxarifado
              open={isModalCategoriaOpen}
              onClose={() => setIsModalCategoriaOpen(false)}
              onSelect={(categoria) => {
                setCategoriaSeleccionada(categoria);
                setFieldValue("id_categoria", categoria.id);
                setIdCategoriaActual(categoria.id);
                setIsModalCategoriaOpen(false);
                setIsModalSubcategoriaOpen(true);
              }}
            />
            <ModalSubCategoriasAmoxarifado
              open={isModalSubcategoriaOpen}
              onClose={() => setIsModalSubcategoriaOpen(false)}
              idCategoria={idCategoriaActual}
              nombreCategoria={categoriaSeleccionada?.categoria}
              onSelect={(subcategoria) => {
                setSubcategoriaSeleccionada(subcategoria);
                setFieldValue("id_subcategoria", subcategoria.id);
                setIsModalSubcategoriaOpen(false);
              }}
            />
            <ModalUserData
              open={modalUserOpen}
              onClose={() => setModalUserOpen(false)}
              // idCategoria={idCategoriaActual}
              // nombreCategoria={categoriaSeleccionada?.categoria}
              onSelectUsuario={(user) => {
                // setSubcategoriaSeleccionada(subcategoria);
                setFieldValue("id_usuario", user.id);
                setModalUserOpen(false);
              }}
            />

            <ModalPatrimonio
              open={modalPatrimonio}
              onClose={() => {
                setModalPatrimonio(false);
                setModalJustClosed(true);
                setTimeout(() => setModalJustClosed(false), 100);
              }}
              sector={sectorSeleccionado}
              onSelectPatrimonio={(patrimonio) => {
                setFieldValue("id_patrimonio", patrimonio.id);

                // Cierra todos los modales relacionados
                setModalPatrimonio(false);
                setModalSector(false);

                // Evita que el onFocus los reabra inmediatamente
                setModalJustClosed(true);
                setTimeout(() => setModalJustClosed(false), 100);
              }}
            />

            <ModalSector
              open={modalSector}
              onClose={() => {
                setModalSector(false);
                setModalJustClosed(true);
                setTimeout(() => setModalJustClosed(false), 100); // evita reabrir inmediatamente
              }}
              onSelectSector={(sector) => {
                setSectorSeleccionado(sector);
                setFieldValue("id_sector", sector.id); // si quieres guardar el sector
                setModalSector(false);
                setModalPatrimonio(true);
                setModalJustClosed(true);
                setTimeout(() => setModalJustClosed(false), 100);
              }}
            />
          </>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  // producto: yup.string().required("El producto es requerido"),
  // cantidad: yup.number().required("La Cantidad es requerida"),
  // id_patrimonio: yup.number().required("Este campo es requerido"),
  // // id_sector: yup.number().required("Este campo es requerido"),
  // id_producto: yup.number().required("Este campo es requerido"),
  // id_usuario: yup.number().required("Este campo es requerido"),
});

export default SalidaProduct;
